import { createSbpTokenBindingApi2 } from '../../api/create-sbp-token-binding-v2';
import { ApiHost, BindSbpTokenOptionsV2, PaymentFrameEventsV2 } from '../../types';
import { paymentForm } from '../payment-form';

export const bindSbpTokenV2 = async (apiHost: ApiHost, options: BindSbpTokenOptionsV2) => {
    const url = await createSbpTokenBindingApi2(apiHost, options);

    return paymentForm<PaymentFrameEventsV2>(apiHost, { url });
};
